import { render, staticRenderFns } from "./donut-chart.vue?vue&type=template&id=7694436a"
import script from "./donut-chart.vue?vue&type=script&lang=js"
export * from "./donut-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports